// NPM Imports
import React, { Component, Fragment } from "react";
import { Button } from "@revvsales/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Components Imports
import TitleBar from "../../TitleBar";

import KanbanHeaderSearch from "./KanbanHeaderSearch";
import AssetCreateDocumentPopup from "../../AssetWrapper/AssetHeader/AssetCreateDocumentPopup";
// Actions Imports

// Internal Imports
import { EVENTS } from "../../../constants";
import { AmplitudeUtils } from "../../../utils";

// Destructuring
const { amplitudeLogEvent } = AmplitudeUtils;

class KanbanHeader extends Component {
  state = {
    newDocumentPopup: false,
  };

  _toggleNewDocumentPopup = () => {
    const { newDocumentPopup } = this.state;
    this.setState({ newDocumentPopup: !newDocumentPopup });
    if (!newDocumentPopup) {
      amplitudeLogEvent(EVENTS.EVENT_NAMES.CREATE_DOC_CLICKED, {
        initiatedFrom: "Kanban",
      });
    }
  };

  render() {
    const { newDocumentPopup } = this.state;
    return (
      <Fragment>
        <div className="kanbanheader-container">
          <TitleBar
            iconName="columns"
            title="Pipeline"
            subTitle="All your documents"
          />
          <div className="kanbanheader-right-aligned">
            <Button
              className="kanbanheader-create"
              id="kanbanheader-create"
              data-test="asset-create-document-btn"
              type="button"
              onClick={() => this._toggleNewDocumentPopup()}>
              <i>
                <FontAwesomeIcon icon={["far", "plus"]} />
              </i>
              Create document
            </Button>
            <KanbanHeaderSearch />
          </div>
        </div>

        {newDocumentPopup && (
          <AssetCreateDocumentPopup
            isOpen={newDocumentPopup}
            togglePopup={this._toggleNewDocumentPopup}
            source="kanban"
          />
        )}
      </Fragment>
    );
  }
}

export default KanbanHeader;



// WEBPACK FOOTER //
// ./src/components/Kanban/KanbanHeader/index.js